import {useState, useCallback} from "react";
import type {Status} from "../../types";

type ConfirmCheckAllData = {
    status: Status;
    leafNodeIds: string[];
};

type ModalState =
    | {type: "none"}
    | {type: "editFilling"}
    | {type: "createFilling"}
    | {type: "openFilling"}
    | {type: "shareFilling"}
    | {type: "duplicateFilling"}
    | {type: "deleteFilling"}
    | {type: "confirmCheckAll"; data: ConfirmCheckAllData};

export const useChecklistModals = () => {
    const [modalState, setModalState] = useState<ModalState>({type: "none"});

    const openEditFilling = useCallback(() => {
        setModalState({type: "editFilling"});
    }, []);

    const openCreateFilling = useCallback(() => {
        setModalState({type: "createFilling"});
    }, []);

    const openOpenFilling = useCallback(() => {
        setModalState({type: "openFilling"});
    }, []);

    const openShareFilling = useCallback(() => {
        setModalState({type: "shareFilling"});
    }, []);

    const openDuplicateFilling = useCallback(() => {
        setModalState({type: "duplicateFilling"});
    }, []);

    const openDeleteFilling = useCallback(() => {
        setModalState({type: "deleteFilling"});
    }, []);

    const openConfirmCheckAll = useCallback((data: ConfirmCheckAllData) => {
        setModalState({type: "confirmCheckAll", data});
    }, []);

    const closeModal = useCallback(() => {
        setModalState({type: "none"});
    }, []);

    return {
        modalState,
        isEditFillingOpen: modalState.type === "editFilling",
        isCreateFillingOpen: modalState.type === "createFilling",
        isOpenFillingOpen: modalState.type === "openFilling",
        isShareFillingOpen: modalState.type === "shareFilling",
        isDuplicateFillingOpen: modalState.type === "duplicateFilling",
        isDeleteFillingOpen: modalState.type === "deleteFilling",
        confirmCheckAllData:
            modalState.type === "confirmCheckAll"
                ? modalState.data
                : undefined,
        openEditFilling,
        openCreateFilling,
        openOpenFilling,
        openShareFilling,
        openDuplicateFilling,
        openDeleteFilling,
        openConfirmCheckAll,
        closeModal,
    };
};
